module.exports = __webpack_public_path__ + "a01404c6eae08e537a25c1b8865ed004.png";